import React from "react";
import { Popconfirm } from "antd";
import { IImageCard } from "../type/media-hub.types";
import { Download, Info, Trash } from "lucide-react";

const ImageCard: React.FC<IImageCard> = ({
                                             item,
                                             isAdmin,
                                             isSelected,
                                             imageUrl,
                                             onPreview,
                                             onToggleSelect,
                                             onDownload,
                                             onDelete,
                                             onShowDetails
                                         }) => {
    return (
        <div
            className={`image-cards__image-view ${isSelected ? "selected" : ""}`}
        >
            <img
                src={imageUrl}
                alt="gallery"
                className="images"
                onClick={() => onPreview(item.id)}
                style={{cursor: "pointer"}}
            />

            <div className="image-cards__overlay">
                <input
                    type="checkbox"
                    className="image-checkbox"
                    checked={isSelected}
                    onChange={() => onToggleSelect(item.id)}
                />

                <div className={'action-btns'}>
                    <Download onClick={() => onDownload(item)} className={'action-download'}/>

                    {isAdmin &&
                    <Popconfirm
                        title="Delete the Image"
                        description={
                            <p>Are you sure you want to delete this image?</p>
                        }
                        onConfirm={() => onDelete(item.id)}
                    >
                        <Trash className={'action-delete'}/>
                    </Popconfirm>
                    }

                    <Info className={'action-info'} onClick={(e) => {
                        e.preventDefault();
                        onShowDetails(item)
                    }}/>
                </div>

            </div>
        </div>
    );
};

export default React.memo(ImageCard);
